<template>
  <div>
    <div class="container-buttons">
      <router-link to="/cadastrar-combo">
        <button class="btn-custom btn-cobranca mb-3">
          <i class="fa fa-plus"></i> Cadastrar Combo
        </button>
      </router-link>
    </div>
    <card title="Todos os combos" subTitle="combos cadastrados">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Nome</th>
            <th>Plano de Internet</th>
            <th>Plano de TV</th>
            <th>Plano de Telefone</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="combo in combos">
              <td>{{ combo.id }}</td>
              <td>{{ combo.name }}</td>
              <td>
                {{ combo.internetPlan ? combo.internetPlan.name : "N/D" }}
              </td>
              <td>{{ combo.tvPlan ? combo.tvPlan.name : "N/D" }}</td>
              <td>{{ combo.phonePlan ? combo.phonePlan.name : "N/D" }}</td>
              <td>
                <p-button
                  v-if="!combo.recommended"
                  type="success"
                  outline
                  icon
                  title="Recomendar combo"
                  @click.prevent.native="recommend(combo.id, true)"
                >
                  <i class="fa fa-check-circle"></i>
                </p-button>
                <p-button
                  v-else
                  type="success"
                  outline
                  icon
                  title="Remover Recomendado"
                  @click.prevent.native="recommend(combo.id, false)"
                >
                  <i class="fa fa-times"></i>
                </p-button>
                <p-button
                  v-if="!combo.internal"
                  type="primary"
                  outline
                  icon
                  title="Ocultar combo do site"
                  @click.prevent.native="internalize(combo.id, true)"
                >
                  <i class="fa fa-times"></i>
                </p-button>
                <p-button
                  v-else
                  type="primary"
                  outline
                  icon
                  title="Mostrar combo no site"
                  @click.prevent.native="internalize(combo.id, false)"
                >
                  <i class="fa fa-check-circle"></i>
                </p-button>
                <p-button
                  type="danger"
                  outline
                  icon
                  title="Apagar combo"
                  @click.prevent.native="remove(combo.id)"
                >
                  <i class="fa fa-ban btn-delete"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination,
  },
  computed: {
    combos() {
      return this.$store.getters.combos;
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["fetchCombos", "updateCombo", "deleteCombo"]),
    async recommend(id, recommended) {
      try {
        await this.updateCombo({
          id,
          body: {recommended},
        });
        await Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Combo atualizado com sucesso",
        });
      } catch (err) {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao atualizar combo",
        });
      }
    },
    async internalize(id, internal) {
      try {
        await this.updateCombo({
          id,
          body: {internal},
        });
        await Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Combo atualizado com sucesso",
        });
      } catch (err) {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao atualizar combo",
        });
      }
    },
    async remove(id) {
      try {
        await this.deleteCombo({id});
        await Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Combo removido com sucesso",
        });
      } catch (err) {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao remover combo",
        });
      }
    },
  },
  async mounted() {
    try {
      await this.fetchCombos();
    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Erro ao carregar os combos",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container_filtro {
  display: flex;
  justify-content: flex-end;
}
.container_filtro select {
  width: 15vw;
}
.container_filtro div:first-child {
  margin-right: 10px;
}
.container-buttons {
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}
</style>
